import { SparklesIcon, RefreshIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface RailHeaderProps {
  onNewConversation?: () => void;
  newConversationDisabled?: boolean;
}

export const RailHeader = ({
  onNewConversation,
  newConversationDisabled = true,
}: RailHeaderProps) => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClick = () => {
    if (!onNewConversation || newConversationDisabled) return;
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    onNewConversation?.();
  };

  return (
    <>
      <div className="flex items-center gap-1.5 mb-2">
        <SparklesIcon className="h-4 w-4 text-green-500 shrink-0" />
        <span className="text-sm font-medium flex-1 truncate">
          {t("general.assistantScenarIa.title")}
        </span>
        <button
          type="button"
          className="p-0.5 text-gray-400 hover:text-gray-600 disabled:opacity-40 disabled:cursor-not-allowed"
          onClick={handleClick}
          disabled={newConversationDisabled}
          aria-label={t("general.assistantScenarIa.newConversation") as string}
          title={t("general.assistantScenarIa.newConversation") as string}
        >
          <RefreshIcon className="h-4 w-4" />
        </button>
      </div>
      {confirmOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
          role="dialog"
          aria-modal="true"
        >
          <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-sm mx-3">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">
              {t("general.assistantScenarIa.reset.title")}
            </h3>
            <p className="text-xs text-gray-600 mb-3">
              {t("general.assistantScenarIa.reset.confirm")}
            </p>
            <div className="flex items-center justify-end gap-2">
              <button
                type="button"
                className="text-xs px-3 py-1.5 rounded-md text-gray-600 hover:bg-gray-100"
                onClick={() => setConfirmOpen(false)}
              >
                {t("general.assistantScenarIa.reset.cancel")}
              </button>
              <button
                type="button"
                className="text-xs px-3 py-1.5 rounded-md bg-green-100 text-green-700 border border-green-200 hover:bg-green-200"
                onClick={handleConfirm}
              >
                {t("general.assistantScenarIa.reset.confirmButton")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RailHeader;
